// Module
var code = "<react-component name=\"ChangelogItem\"></react-component>\n";
// Exports
module.exports = code;